'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Button from '../Button/index.js';
import CloseIcon from '../Images/CloseIcon/index.js';
import { PopupWrapper, BackdropWrapper, PopupContentWrapper, PopupContent, TopWrapper, Body, CustomBody, Header, HeaderText, Footer, Column, MoreFooterButton } from './Popup.css.js';
import translations from './translation.js';
import { DEFAULT_STYLE_OPTION, DEFAULT_OPTION, DEFAULT_HEIGHT_FIX } from './constants.js';
import { isMobile } from '../Utils/helpers.js';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useScrollLock from '../hooks/useScrollLock.js';

var Popup = function (props) {
    var _a;
    var isShow = props.isShow, _b = props.custom, custom = _b === void 0 ? null : _b, children = props.children, _c = props.text, text = _c === void 0 ? null : _c, lang = props.lang, styleOption = props.styleOption, option = props.option, onClickPrimary = props.onClickPrimary, onClickOutside = props.onClickOutside, onClose = props.onClose, _d = props.className, className = _d === void 0 ? '' : _d, customActionPopup = props.customActionPopup;
    var mergedStyleOption = __assign(__assign({}, DEFAULT_STYLE_OPTION), styleOption);
    var mergedOption = __assign(__assign({}, DEFAULT_OPTION), option);
    var bodyOverflow = (custom === null || custom === void 0 ? void 0 : custom.bodyOverflow) || 'auto';
    var bodyNode = typeof document !== 'undefined' ? document === null || document === void 0 ? void 0 : document.querySelector('body') : null;
    var _e = useState(), headerHeight = _e[0], setHeaderHeight = _e[1];
    var _f = useState(), footerHeight = _f[0], setFooterHeight = _f[1];
    var customRef = useCallback(function (node, ref) {
        if (node === null)
            return;
        switch (ref) {
            case 'header':
                setHeaderHeight(node.clientHeight);
                break;
            case 'footer':
                setFooterHeight(node.clientHeight);
                break;
        }
    }, []);
    /*
     * when toggle popup, it add and remove overflow: hidden on body tag.
     * On ios device, this action make header on mobile flickering when scroll up and doww.
     * So we must delay the close popup state to fix this bug
     * */
    var _g = customActionPopup || {}, _h = _g.enable, enableCustomPopup = _h === void 0 ? false : _h, actionCustomPopupAfterShow = _g.actionCustomPopupAfterShow, _j = _g.delayTime, delayTime = _j === void 0 ? 100 : _j;
    var _k = useState(isShow), customActionPopupState = _k[0], setCustomActionPopupState = _k[1];
    var _l = useState(false), isMounted = _l[0], setMounted = _l[1];
    var _m = useScrollLock({
        autoLock: (custom === null || custom === void 0 ? void 0 : custom.autoLockScroll) || false,
        lockTarget: custom === null || custom === void 0 ? void 0 : custom.lockTarget
    }), lock = _m.lock, unlock = _m.unlock;
    var isPopupOpened = useRef(false);
    var isInMobile = isMobile();
    var getPopupState = useMemo(function () {
        if (enableCustomPopup) {
            return customActionPopupState;
        }
        return isShow;
    }, [enableCustomPopup, isShow, customActionPopupState]);
    var updatePushView = function () {
        // Is in mobile and option isPushViewBehind true
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        bodyNode.style.backgroundColor = '#000';
        rootElement.style.transition = '0.4s ease';
        rootElement.style.transform = "translate(0, ".concat(window.scrollY < DEFAULT_HEIGHT_FIX ? "-".concat(DEFAULT_HEIGHT_FIX - window.scrollY, "px") : 0, ") scale(0.9)");
        rootElement.style.borderRadius = '12px';
        rootElement.style.backgroundColor = '#fff';
    };
    useEffect(function () {
        var _a;
        setCustomActionPopupState(isShow);
        if (isShow) {
            setMounted(isShow);
            if (!isPopupOpened.current) {
                lock();
                isPopupOpened.current = true;
            }
        }
        else {
            if (isPopupOpened.current) {
                unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
                isPopupOpened.current = false;
            }
        }
    }, [isShow, lock, unlock, (_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode]);
    useEffect(function () {
        if (!enableCustomPopup) {
            return;
        }
        if (!isShow) {
            setTimeout(function () {
                setCustomActionPopupState(false);
                actionCustomPopupAfterShow && actionCustomPopupAfterShow();
            }, delayTime);
            return;
        }
        setCustomActionPopupState(isShow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableCustomPopup, delayTime, isShow]);
    useEffect(function () {
        if (!bodyNode) {
            return;
        }
        var resetBodyPopupPush = function () {
            if (!isInMobile) {
                return;
            }
            if (!mergedStyleOption.isPushViewBehind) {
                return;
            }
            // Make sure it will not action when bodyDiv element was not exist
            if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
                return;
            }
            var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
            if (rootElement === null) {
                return;
            }
            rootElement.style.transform = 'initial';
        };
        // lock scrolling on body
        if (isShow) {
            updatePushView();
        }
        else {
            resetBodyPopupPush();
        }
        // Component will unmount
        return function () {
            resetBodyPopupPush();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyNode, isInMobile, isShow]);
    if (!bodyNode) {
        return React__default.createElement(React__default.Fragment, null);
    }
    if (!isMounted) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var doClosePopup = function () {
        var _a;
        if (enableCustomPopup) {
            setCustomActionPopupState(false);
        }
        unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
        onClose && onClose();
    };
    var handleOnClickSecondary = function () {
        var _a;
        if (mergedOption.isReverseAction) {
            onClickPrimary && onClickPrimary();
            unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
            return;
        }
        doClosePopup();
    };
    var handleOnClickPrimary = function () {
        var _a;
        if (mergedOption.isReverseAction) {
            doClosePopup();
            return;
        }
        onClickPrimary && onClickPrimary();
        unlock((_a = props.custom) === null || _a === void 0 ? void 0 : _a.scrollLockMode);
    };
    var handleOnClickBackdrop = function () {
        onClickOutside && onClickOutside();
        if (mergedOption.isCloseOnClickBackdrop) {
            doClosePopup();
        }
    };
    var onAnimationEndClosePushView = function () {
        if (!isInMobile) {
            return;
        }
        if (!mergedStyleOption.isPushViewBehind) {
            return;
        }
        // Make sure it will not action when bodyDiv element was not exist
        if (!mergedStyleOption.bodyDivQuerySelector || mergedStyleOption.bodyDivQuerySelector === '') {
            return;
        }
        var rootElement = document.querySelector(mergedStyleOption.bodyDivQuerySelector);
        if (bodyNode === null || rootElement === null) {
            return;
        }
        rootElement.style.overflow = 'initial';
        rootElement.style.height = 'initial';
        rootElement.style.borderRadius = 'initial';
        bodyNode.style.backgroundColor = 'initial';
    };
    var onAnimationEnd = function () {
        if (getPopupState) {
            return;
        }
        onAnimationEndClosePushView();
        setMounted(false);
    };
    var calculateBodyHeight = function () {
        var _a;
        if (typeof window === 'undefined') {
            return "100vh";
        }
        if (custom === null || custom === void 0 ? void 0 : custom.isPopupCenter) {
            return '';
        }
        var height = window.innerHeight;
        var headerHeight = 61;
        var footerHeight = 90;
        var additionalFooterHeight = (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0;
        var isHaveCustomFooter = (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined;
        if (isHaveCustomFooter) {
            footerHeight = 0;
        }
        if (!isHaveCustomFooter && (custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert)) {
            footerHeight = 123;
        }
        // Calculate body height by removed all other element height
        // 34px is margin-top pixel of main popup
        return "".concat(height - headerHeight - footerHeight - 34 - additionalFooterHeight, "px");
    };
    /**
     * Render
     */
    var renderHeader = function () {
        return (React__default.createElement("div", { ref: function (node) { return customRef(node, 'header'); } }, (custom === null || custom === void 0 ? void 0 : custom.header) !== undefined ? (custom.header) : (React__default.createElement(Header, { isCenterTitle: mergedStyleOption.isCenterTitle, bgColor: mergedStyleOption.headerBg },
            React__default.createElement(HeaderText, { textColor: mergedStyleOption.headerTextColor }, text === null || text.header === undefined ? t('Alert') : text.header),
            mergedOption.isShowClose ? (React__default.createElement(Button, { className: 'close-btn', isRounded: true, isIcon: true, type: 'transparent', onClick: function () { return doClosePopup(); } },
                React__default.createElement(CloseIcon, { fill: mergedStyleOption.closeIconColor }))) : null))));
    };
    var renderFooter = function () {
        var primaryBtnStyle = {};
        if (mergedOption.isShowPrimaryButton && mergedStyleOption.primaryBtnWidth !== '') {
            primaryBtnStyle = {
                width: mergedStyleOption.primaryBtnWidth
            };
        }
        return (React__default.createElement("div", { ref: function (node) { return customRef(node, 'footer'); } }, (custom === null || custom === void 0 ? void 0 : custom.footer) !== undefined ? (custom.footer) : (React__default.createElement(Footer, { isShow: getPopupState, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, isCenter: mergedOption.isCenterFooter, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), isFooterButtonFullWidth: mergedStyleOption.isFooterButtonFullWidth },
            (custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert) ? React__default.createElement(Column, null, custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert) : null,
            React__default.createElement(Column, null,
                (custom === null || custom === void 0 ? void 0 : custom.footerButtons) !== undefined
                    ? custom === null || custom === void 0 ? void 0 : custom.footerButtons.map(function (item, index) {
                        return React__default.createElement(MoreFooterButton, { key: "footer-button-".concat(index) }, item);
                    })
                    : null,
                mergedOption.isShowSecondaryButton && (React__default.createElement(Button, { type: mergedStyleOption.secondaryBtnStyle, outline: mergedStyleOption.secondaryBtnOutline, onClick: handleOnClickSecondary }, text === null || text.secondaryBtn === undefined ? t('Cancel') : text.secondaryBtn)),
                mergedOption.isShowPrimaryButton && (React__default.createElement(Button, { disabled: (option === null || option === void 0 ? void 0 : option.disabledPrimary) || false, type: mergedStyleOption.primaryBtnStyle, outline: mergedStyleOption.primaryBtnOutline, onClick: handleOnClickPrimary, style: primaryBtnStyle }, text === null || text.primaryBtn === undefined ? t('Yes') : text.primaryBtn)))))));
    };
    var renderCustom = function () {
        var _a;
        var bodyHeight = calculateBodyHeight();
        return (React__default.createElement(React__default.Fragment, null,
            renderHeader(),
            (custom === null || custom === void 0 ? void 0 : custom.withDefaultBody) ? (React__default.createElement(Body, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null, additionalFooterHeight: (_a = custom === null || custom === void 0 ? void 0 : custom.additionalFooterHeight) !== null && _a !== void 0 ? _a : 0 }, children)) : (React__default.createElement(CustomBody, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, isHaveLeftFooter: !!(custom === null || custom === void 0 ? void 0 : custom.leftFooterAlert), responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null }, children)),
            renderFooter()));
    };
    var renderPopupDefault = function () {
        var bodyHeight = calculateBodyHeight();
        return (React__default.createElement(React__default.Fragment, null,
            renderHeader(),
            React__default.createElement(Body, { className: custom === null || custom === void 0 ? void 0 : custom.bodyClass, overflow: bodyOverflow, responsiveHeight: bodyHeight, headerHeight: headerHeight || null, footerHeight: footerHeight || null }, children),
            renderFooter()));
    };
    return createPortal(React__default.createElement(React__default.Fragment, null,
        React__default.createElement(PopupWrapper, { className: className, isShow: getPopupState, isDisplayNone: mergedStyleOption.isDisplayNone },
            React__default.createElement(BackdropWrapper, { isShowBackdrop: mergedOption.isShowBackdrop, onClick: handleOnClickBackdrop, clickableBackdrop: mergedOption.isCloseOnClickBackdrop }),
            React__default.createElement(PopupContentWrapper, null,
                React__default.createElement(PopupContent, { isShow: getPopupState, className: "vnw-popup-content ".concat(mergedStyleOption.className), size: mergedStyleOption.size, isFullScreenOnMobile: mergedOption.isFullScreenOnMobile, onAnimationEnd: onAnimationEnd, isHaveBorder: mergedStyleOption.isHaveBorder, isPopupCenter: custom === null || custom === void 0 ? void 0 : custom.isPopupCenter }, custom !== null ? renderCustom() : renderPopupDefault()))),
        mergedStyleOption.isPushViewBehind && createPortal(React__default.createElement(TopWrapper, { isShow: getPopupState }), bodyNode)), bodyNode);
};

export { Popup as default };
//# sourceMappingURL=index.js.map
